import DocumentationButton from "components/DocumentationButton";
import { EmptystateStacksColored } from "components/icons/generated";
import Box from "ds/components/Box";
import LinkButton from "ds/components/Button/LinkButton";
import EmptyState from "ds/components/EmptyState";
import TileWrapper from "ds/components/Tile/Wrapper";
import { AnalyticsPageDashboard } from "hooks/useAnalytics/pages/dashboard";
import { getDocsUrl } from "utils/getDocsUrl";
import useCanCreateStack from "shared/Stack/access/useCanCreateStack";
import Tooltip from "ds/components/Tooltip";

import { Widget } from "../types";

type DashboardWidgetsEmptyStateStacksProps = {
  widget?: Widget;
};

const DashboardWidgetsEmptyStateStacks = ({ widget }: DashboardWidgetsEmptyStateStacksProps) => {
  const canCreateStack = useCanCreateStack();

  return (
    <TileWrapper>
      <Box padding="small" fullWidth justify="center">
        <EmptyState
          title="You don’t have any stacks yet"
          icon={EmptystateStacksColored}
          caption="Spacelift is no fun without stacks and you haven't created one yet. Create one now, or learn more from our documentation."
        >
          <Box gap="medium">
            <DocumentationButton
              analyticsPage={AnalyticsPageDashboard.Dashboard}
              analyticsTitle="Widget - Documentation Clicked"
              analyticsProps={{ widget }}
              to={getDocsUrl("/concepts/stack")}
              label="Documentation"
            />

            <Tooltip
              active={!!canCreateStack.message}
              on={(tooltipProps) => (
                <LinkButton
                  {...tooltipProps}
                  variant="primary"
                  to="/new/stack"
                  disabled={!canCreateStack.result}
                >
                  Create stack
                </LinkButton>
              )}
            >
              {canCreateStack.message}
            </Tooltip>
          </Box>
        </EmptyState>
      </Box>
    </TileWrapper>
  );
};

export default DashboardWidgetsEmptyStateStacks;
